export const APP_CONFIG_STORAGE_ID = 'appConfig';
